import { hydrateInteractiveWidgets } from './hydrate';
import { openAccordionDialog } from './accordion';
import { openFlipCardDialog } from './flipCard';
import { openTimelineDialog } from './timeline';
import { openMatchDialog } from './matchDragDrop';
import { openKnowledgeCheckDialog } from './knowledgeCheck';

const INTERACTIVE_ICON = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="currentColor" d="M4 5.5A1.5 1.5 0 0 1 5.5 4h5A1.5 1.5 0 0 1 12 5.5v5A1.5 1.5 0 0 1 10.5 12h-5A1.5 1.5 0 0 1 4 10.5v-5zm8.75 0A1.5 1.5 0 0 1 14.25 4h5A1.5 1.5 0 0 1 20.75 5.5v5a1.5 1.5 0 0 1-1.5 1.5h-5a1.5 1.5 0 0 1-1.5-1.5v-5zM4 14.25A1.5 1.5 0 0 1 5.5 12.75h5a1.5 1.5 0 0 1 1.5 1.5v5A1.5 1.5 0 0 1 10.5 21h-5A1.5 1.5 0 0 1 4 19.5v-5zm10.1.05 2.05-2.05 4.1 4.1-2.05 2.05-4.1-4.1zm-1.5 2.6 4.1 4.1 2.05-2.05-4.1-4.1-2.05 2.05z"/></svg>`;

export const INTERACTIVE_MENU_ITEMS = [
  { action: 'mcAccordion', label: 'Accordion' },
  { action: 'mcFlipCard', label: 'Flip card' },
  { action: 'mcTimeline', label: 'Timeline' },
  { action: 'mcMatch', label: 'Match drag-and-drop' },
  { action: 'mcKnowledgeCheck', label: 'Knowledge check quiz' },
];

export const getInteractiveGroupButton = () => ({
  name: 'mcInteractive',
  tooltip: 'Interactive content',
  icon: INTERACTIVE_ICON,
  list: {
    mcAccordion: 'Accordion',
    mcFlipCard: 'Flip card',
    mcTimeline: 'Timeline',
    mcMatch: 'Match drag-and-drop',
    // mcKnowledgeCheck: 'Knowledge check quiz',
  },
  exec: (editor, _current, options) => {
    const control = options?.control || options;
    const action = control?.args?.[0];
    if (!action) {
      return false;
    }
    openWidgetByAction(editor, action);
    return true;
  },
});

const OPENERS = {
  accordion: openAccordionDialog,
  flipcard: openFlipCardDialog,
  timeline: openTimelineDialog,
  match: openMatchDialog,
  // 'knowledge-check': openKnowledgeCheckDialog,
};

const ACTION_OPENERS = {
  mcAccordion: openAccordionDialog,
  mcFlipCard: openFlipCardDialog,
  mcTimeline: openTimelineDialog,
  mcMatch: openMatchDialog,
  // mcKnowledgeCheck: openKnowledgeCheckDialog,
};

export const openWidgetByAction = (editor, action) => {
  const opener = ACTION_OPENERS[action];
  if (!opener) {
    return false;
  }
  opener(editor);
  return true;
};

const widgetType = (widget) =>
  widget.getAttribute('data-mc-widget') ||
  [...widget.classList]
    .find((name) => name.startsWith('mc-') && name !== 'mc-widget')
    ?.replace(/^mc-/, '');

const openFromWidget = (editorInstance, widget) => {
  const opener = OPENERS[widgetType(widget)];
  if (!opener) {
    return;
  }
  opener(editorInstance, widget);
};

export const bindWidgetEvents = (editorInstance) => {
  const root = editorInstance.editor;
  const hydrateEditor = () => {
    if (!root) {
      return;
    }
    hydrateInteractiveWidgets(root, {
      stripChrome: false,
      shuffleMatch: false,
    });
  };

  let hydrateTimer;
  const scheduleHydrate = () => {
    window.clearTimeout(hydrateTimer);
    hydrateTimer = window.setTimeout(hydrateEditor, 120);
  };

  const handleEdit = (event) => {
    const edit = event.target?.closest?.('[data-mc-edit]');
    if (!edit) {
      return;
    }
    const widget = edit.closest('.mc-widget');
    if (!widget || (root && !root.contains(widget))) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    openFromWidget(editorInstance, widget);
  };

  root?.addEventListener(
    'mousedown',
    (event) => {
      if (event.target?.closest?.('[data-mc-edit]')) {
        event.preventDefault();
      }
    },
    true,
  );
  root?.addEventListener('click', handleEdit, true);
  editorInstance.e.on('click', handleEdit);
  hydrateEditor();
  editorInstance.e.on('change', scheduleHydrate);
};
